import type { MasterDataItem, MasterDataKind } from '../api/types'
import { t } from '../i18n/lingua'

/**
 * La scelta di una voce d'anagrafica (centro di costo, unità organizzativa,
 * sede): un menu con l'albero rientrato, «nessuna» in testa. Le voci
 * disattivate non si propongono, ma se una è già scelta resta visibile.
 */
export function SelettoreAnagrafica({
  kind, voci, value, onChange, id, disabled,
}: {
  kind: MasterDataKind
  voci: MasterDataItem[]
  value: string | null | undefined
  onChange: (id: string | null) => void
  id?: string
  disabled?: boolean
}) {
  const scelta = voci.find((v) => v.id === value)
  return (
    <select id={id} value={value ?? ''} onChange={(e) => onChange(e.target.value || null)} disabled={disabled}
            aria-label={etichettaAnagrafica(kind)}>
      <option value="">{t('nessuna')}</option>
      {voci.filter((v) => v.active || v.id === value).map((v) => (
        <option key={v.id} value={v.id}>
          {'  '.repeat(v.level ?? 0)}{v.code !== v.name ? `${v.code} · ${v.name}` : v.name}{v.active ? '' : ` (${t('disattivata')})`}
        </option>
      ))}
      {value && !scelta && <option value={value}>{t('voce non più in anagrafica')}</option>}
    </select>
  )
}

export function etichettaAnagrafica(kind: MasterDataKind): string {
  switch (kind) {
    case 'cost_center':
      return t('Centro di costo')
    case 'org_unit':
      return t('Unità organizzativa')
    default:
      return t('Sede')
  }
}

/** «codice · nome» di una voce, o un trattino. */
export function nomeAnagrafica(voci: MasterDataItem[] | undefined, id: string | null | undefined): string {
  if (!id) return '—'
  const v = voci?.find((x) => x.id === id)
  if (!v) return t('voce non più in anagrafica')
  return v.code !== v.name ? `${v.code} · ${v.name}` : v.name
}
